import { action } from '@ember/object';
import StrategyCalculation from '../StrategyCalculation';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import ScenarioValidations from 'scaleflow/validators/scenario';
import { task } from 'ember-concurrency';

export default class StrategyStrategyFormIndexComponent extends StrategyCalculation {
  @service organisation;
  @service router;
  @service store;
  scenarioValidations = ScenarioValidations;

  @tracked isDisabled = true;

  unavailable_types = ['holidays', 'pto', 'sick_leave', 'other'];

  startDatePicker = null;
  endDatePicker = null;

  get ppw() {
    return this.organisation.ppw;
  }

  get scenario() {
    return this.args.scenario;
  }

  @tracked showPpwSlideover = false;

  @action
  togglePpwSlideover(val = undefined) {
    if (val === undefined) this.showPpwSlideover = !this.showPpwSlideover;
    else this.showPpwSlideover = val;
  }

  @action
  handleBlur(changeset) {
    changeset.validate();
  }

  @action
  handleInput(changeset, e) {
    changeset.set(e.target.id, +e.target.value);
  }

  @action
  onReady(field, _, __, e) {
    this[field] = e;
  }

  @action
  openDatePicker(field) {
    this[field].toggle();
  }

  @action
  onDateChange(changeset, field, e) {
    changeset.set(field, e[0]);
  }

  @action
  goToViewPage() {
    this.router.transitionTo('planning.dashboard.balance');
  }

  isNew(changeset) {
    return !changeset.get('id');
  }

  @action
  resetForm(changeset) {
    changeset.rollback();
    if (this.isNew(changeset)) this.scenario.deleteRecord();
    this.goToPreviousPage();
  }

  fillDerivedOpsFlexValues(changeset) {
    const initiative_capacity = +changeset.get('initiative_capacity');
    if (!initiative_capacity || isNaN(initiative_capacity)) return;
    const ops_flex = 100 - initiative_capacity;
    changeset.set('ops_flex', ops_flex);
    changeset.set('price_person_week', this.organisation.ppw);
  }

  saveSettings = task({}, async (changeset, e) => {
    this.fillDerivedOpsFlexValues(changeset);

    e.preventDefault();
    if (changeset.get('isDirty')) {
      this.nothingChanged = false;
      changeset.validate().then(() => {
        if (changeset.get('isValid')) {
          changeset
            .save()
            .then(() => {
              this.submittedOnce = true;
              this.afterSubmit(changeset);
              this.store.findRecord('investment-scenario', changeset.get('id'));
            })
            .catch((err) => {
              console.log(err, 'err');
              changeset
                .get(this, 'model.errors')
                .forEach(({ attribute, message }) => {
                  changeset.addError(attribute, message);
                });
            });
        } else console.log(changeset.errors);
      });
      // if there is an extra action that needs to be done after the form is submitted
    } else {
      this.saveSettings.cancelAll();
    }
  });

  @action
  afterSubmit() {
    this.saveSettings.cancelAll();
    this.goToPreviousPage();
  }

  @action
  sumOfUnavailableTime(unavailable_time) {
    const unavailable = unavailable_time?.content ?? unavailable_time ?? {};
    return Object.entries(unavailable).reduce((acc, item) => {
      const [label, value] = item;
      if (label === 'total') return acc;
      return (acc += +value);
    }, 0);
  }

  @action
  handleUnavailableInput(changeset, type, e) {
    const _unavailable_time =
      changeset.get('unavailable_time')?.content ??
      changeset.get('unavailable_time') ??
      {};
    const unavailable_time = { ..._unavailable_time };
    unavailable_time[type] = +e.target.value;
    const total = this.sumOfUnavailableTime(unavailable_time);
    unavailable_time['total'] = total;
    changeset.set('unavailable_time', unavailable_time);
  }

  @action
  deleteScenario() {
    this.scenario.destroyRecord().then(() => {
      this.router.replaceWith('planning.dashboard.overview.grid');
    });
  }

  @action
  goToPreviousPage() {
    history.go(-1);
  }
}
